{
  function numberWithCommas(x) {
    if(x.indexOf(".") != -1){
      return x
    }
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function animateValue(obj, start, end, duration, decPlaces = 0, minStep) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) {
        startTimestamp = timestamp;
      }

      const progress = Math.min((timestamp - startTimestamp) / duration, 1)
      let rawNumber = (end - start) + start
      let numberInProgress = progress * rawNumber

      if(minStep != 'auto'){
        numberInProgress = Math.floor(numberInProgress / minStep) * minStep
        if(numberInProgress + minStep > end){
          numberInProgress = end
        }
      }

      let numberWithDecimals = numberInProgress.toFixed(decPlaces)

      const formattedNumber = numberWithCommas(numberWithDecimals)

      obj.innerHTML = formattedNumber

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        obj.innerHTML = numberWithCommas(obj.getAttribute('to'))
      }
    };
    window.requestAnimationFrame(step);
  }

  function decimalPlaces(value) {
    if(Math.floor(value) === value || (value + "").indexOf('.') == -1){ 
      return 0
    } else {
      return value.toString().split(".")[1].length || 0
    }
  }

  class animatedNumber extends HTMLElement {
    _startAnimation(){
      this.setAttribute('animated', true)
      const to = parseFloat(this.getAttribute('to'))
      const speed = parseFloat(this.getAttribute('speed')) || 1000
      const step = parseFloat(this.getAttribute('step')) || 'auto'
      animateValue(this, 0, to, speed, decimalPlaces(to), step)      
    }

    connectedCallback() {

      // admin preview hack fix because gutenberg doesn't like custom elements
      if(this.hasAttribute('className')){
        this.classList = this.getAttribute('className')
        this.removeAttribute('className')
      }
      
      if (window.wp && window.wp.data && typeof window.wp.data.subscribe === 'function') {
        wp.data.subscribe(() => {
          this.innerHTML = numberWithCommas(this.getAttribute('to'))
        })
        return
      }

      const observer = new IntersectionObserver(entries => {
        const entry = entries[0]
        const target = entry.target
        
        if(entry.isIntersecting === true && !target.getAttribute('animated')){
          this._startAnimation()
        }
      }, { threshold: [ 0.5 ] })

      setTimeout(() => {
        observer.observe(this)
      }, 1000)
    }
  }

  customElements.define("animated-number", animatedNumber)
}